import { UPDATE_ACTIVE_INTERVIEW_LINK } from "../actions/types";

//Set initial state to the most recent aid year
const INITIAL_STATE = {
  activeInterviewLink: null
};

 // eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_ACTIVE_INTERVIEW_LINK:
      return {
        ...state,
        activeInterviewLink: action.payload,
      };
    default:
      return state;
  }
};
